// extracted by mini-css-extract-plugin
module.exports = {"container":"_3D8MAvJGBRIqH97nFYWU5e","modeSwitch":"_2Gn0jB4LFo1bmIX09PP0Ga"};